/**
 * Térkép megjelenítő komponens
 * @author Erik Banhalmi 2017.06.27.
 */

export const RealEstateMapComponent = {
	bindings: {
		poi: '<',
		location: '<',
		publicTransportation: '<'
	},
	templateUrl: 'real-estate-map.html',
	controller: class RealEstateMapComponent {
		constructor(NgMap, $timeout, CommonConstants) {
			'ngInject';
			this.NgMap = NgMap;
			this.constants = CommonConstants;
			this.$timeout = $timeout;
			this.icons = {
				doctor: '/static/assets/img/poi-doctor.png',
				pharmacy: '/static/assets/img/poi-doctor.png',
				school: '/static/assets/img/poi-education.png',
				university: '/static/assets/img/poi-education.png',
				grocery_or_supermarket: '/static/assets/img/poi-store.png'
			};
		}
		$onChanges(changes) {
			if (changes.poi && !changes.poi.isFirstChange()) {
				this.mapPois = angular.copy(this.poi);
			}
			if (changes.location && !changes.location.isFirstChange()) {
				this.mapLocation = angular.copy(this.location);
				this.NgMap.getMap().then((map) => {
					map.setCenter({lat: this.mapLocation.lat, lng: this.mapLocation.lng});
					map.panBy(-150,0);
					/* this.$timeout(() => {
						map.setCenter({lat: this.mapLocation.lat, lng: this.mapLocation.lng})
						map.panBy(-150,0);
					},0);*/
				});
			}
			if (changes.publicTransportation && !changes.publicTransportation.isFirstChange()) {
				this.transportation = angular.copy(this.publicTransportation);
			}
		}
	}
};
